<template>
  <div>
    <div class="title-bar">
      <h1>{{ isUpdate ? 'Редактировать Атрибут' : 'Создать Атрибут' }}</h1>

      <div class="title-bar__button-wrapper">
        <router-link class="button-wrapper-link" :to="{name: 'CategoryAttributes'}">
          <el-button type="info">
            <i class="fas fa-list" /> Список
          </el-button>
        </router-link>

        <el-button type="primary" @click="$refs.form.onSubmit()">
          Сохранить
        </el-button>
      </div>
    </div>

    <div class="panel">
      <div class="panel-body">
        <AttributeForm ref="form" />
      </div>
    </div>
  </div>
</template>

<script>
import AttributeForm from '@/pages/categories/AttributeForm';

export default {
  name: 'CreateUpdateAttribute',
  metaInfo: {
    title: 'Создать/Редактировать Категорию',
  },
  components: {AttributeForm},
  computed: {
    isUpdate() {
      return this.$route.name === 'UpdateAttributeForm'
    },
  },
}
</script>

